import React from 'react';

interface Props {
  isOpen: boolean;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmModal({ isOpen, message, onConfirm, onCancel }: Props) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" style={{ zIndex: 9999 }} onClick={onCancel}>
      <div className="modal-content" style={{ maxWidth: '400px', padding: '28px' }} onClick={e => e.stopPropagation()}>
        <h3 style={{ marginTop: 0, marginBottom: '12px', fontSize: '1.2rem', color: '#18181b' }}>Xác nhận</h3>
        <p style={{ color: '#52525b', fontSize: '0.95rem', marginBottom: '28px', lineHeight: 1.5 }}>{message}</p>
        <div className="modal-actions" style={{ marginTop: 0, paddingTop: '20px' }}>
          <button className="button outline small" onClick={onCancel}>Hủy</button>
          <button className="button primary small" style={{ background: '#ef4444', color: 'white', border: 'none', boxShadow: '0 4px 12px rgba(239, 68, 68, 0.25)' }} onClick={onConfirm}>Xóa</button>
        </div>
      </div>
    </div>
  );
}
